import { createSlice } from "@reduxjs/toolkit";

export const queueServiceSlice = createSlice({
  name: "queueService",
  initialState: {
    getQueueServiceResult: false,
    getQueueServiceLoading: false,
    getQueueServiceError: false,
    addQueueServiceResult: false,
    addQueueServiceLoading: false,
  },
  reducers: {
    queueServiceReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_QUEUESERVICE":
          return {
            ...state,
            getQueueServiceResult: payload.data,
            getQueueServiceLoading: payload.loading,
            getQueueServiceError: payload.error,
          };
        case "ADD_QUEUESERVICE":
          return {
            ...state,
            addQueueServiceResult: payload.data,
            addQueueServiceLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { queueServiceReducers } = queueServiceSlice.actions;

export default queueServiceSlice.reducer;
